import React, {
    forwardRef,
    useMemo,
} from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

import {
    useTopic,
    useSearchQueryPlayback,
} from 'bdvp-common/src/hooks/store';
import {
    useDefaultTopic,
    useTeamId,
    useIsClubPage,
} from 'bdvp-common/src/hooks/config';
import { CONTENT_PREFERENCE_CRITERIA } from 'bdvp-advanced-search/src/utils/constants';
import { SEARCH_ROUTE } from 'bdvp-common/src/utils/constants';

import Component from '../components/Row';

const LIMIT = 36;

const Row = forwardRef(({
    skip,
    ssr,
    properties,
    rank,
}, ref) => {

    const defaultTopicId = useDefaultTopic();
    const teamId = useTeamId();
    const isClubPage = useIsClubPage();

    let {
        title: searchTitle,
        advancedSearchCriteria: searchQuery,
        specialType: clubFilter,
    } = properties;

    const isSearchData = !!searchQuery;
    const useData = isSearchData ? useSearchQueryPlayback : useTopic;
    const options = {
        ssr,
        limit: LIMIT,
        skip,
    };

    let id = defaultTopicId;
    let link = `/topic/${id}`;
    let searchParams = `?t=${id}`;

    if (isSearchData) {

        let queryString = decodeURIComponent(searchQuery.split('q=').pop());
        if (isClubPage && clubFilter) {

            queryString = `${clubFilter} == [${teamId}] AND ${queryString}`;

        }
        id = queryString;
        options.contentPreference = CONTENT_PREFERENCE_CRITERIA.mixed;
        searchParams = `?q=${queryString}&pt=${searchTitle}`;
        link = `${SEARCH_ROUTE}?q=${queryString}`;

    }

    const {
        loading,
        loadingMore,
        data,
        error,
        fetchMoreData,
    } = useData(id, options);

    const title = useMemo(() => isSearchData ? searchTitle : _get(data, 'topicPlayList.title', ''), [
        data,
        isSearchData,
        searchTitle,
    ]);
    const list = useMemo(() => _get(data, 'topicPlayList.mediaPlayback', []), [data]);
    const hasMore = useMemo(() => _get(data, 'topicPlayList.hasMore', false), [data]);

    return (
        <Component
            ref={ref}
            title={title}
            list={list}
            hasMore={hasMore}
            error={error}
            fetchMoreData={fetchMoreData}
            isLoading={skip || loading}
            isLoadingMore={loadingMore}
            limit={LIMIT}
            link={link}
            searchParams={searchParams}
            rank={rank}
            isSearchData={isSearchData}
        />
    );

});

Row.propTypes = {
    rank: PropTypes.number.isRequired,
    skip: PropTypes.bool,
    ssr: PropTypes.bool,
    properties: PropTypes.object,
};

Row.defaultProps = {
    skip: false,
    ssr: true,
    properties: {},
};

export default Row;
